export default function SvgTrashCircleIcon(props) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F04438" />
      <path
        d="M25 19H31M19 22H37M35 22L34.2987 32.5193C34.1935 34.0975 34.1409 34.8867 33.8 35.485C33.4999 36.0118 33.0472 36.4353 32.5017 36.6997C31.882 37 31.0911 37 29.5093 37H26.4907C24.9089 37 24.118 37 23.4983 36.6997C22.9528 36.4353 22.5001 36.0118 22.2 35.485C21.8591 34.8867 21.8065 34.0975 21.7013 32.5193L21 22M26 26.5V31.5M30 26.5V31.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#FEE4E2"
        strokeWidth="8"
      />
    </svg>
  )
}
